// import programmeList from '../components/programmeBb/programmeList.vue'
// import viewProgra from '../components/programmeBb/viewProgra.vue'

export default [
    { 
        path: 'programmeBb/ProgrammeList',
        component: resolve => require(['@/components/programmeBb/ProgrammeList'],resolve),
        name:'programmeList',
        meta:{
            id:'946',
            node:'programmeBb',
            url:'ProgrammeList',
        }
    },
    { 
        path: 'programmeBb/viewProgra',
        component: resolve => require(['@/components/programmeBb/viewProgra'],resolve),
        name:'ViewProgra',
        meta:{
            // id:'946',
            node:'programmeBb',
            url:'viewProgra',
        }
    },
]



// WEBPACK FOOTER //
// ./src/router/programmeBb.js